import React, { useEffect, useState } from 'react'
import Close from '~/icons/Close'

export const BotChatTemplate = ({parentProps, toggleChat}) => {

    const [previewAvatar, setPreviewAvatar] = useState('')
    const botName = parentProps.state.botName
    const chatTheme = parentProps.state.chatTheme
    const chatThemeColor = chatTheme?.theme || chatTheme.primaryColor
    const userBubbleTheme = chatTheme?.user
    const botBubbleTheme = chatTheme?.bot
    const widgetTheme = chatTheme?.widget
    function convertFileToDataURL(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()

            reader.onload = function(event: any) {
                resolve(event.target.result)
            }

            reader.onerror = function(error) {
                reject(error)
            }

            reader.readAsDataURL(file)
        })
    }

    useEffect(() => {
        if(typeof parentProps.state.avatarUrl != 'string') {
            convertFileToDataURL(parentProps.state.avatarUrl).then(function (dataURL: any) {
                setPreviewAvatar(dataURL)
                // You can now use the data URL as needed
            }).catch(error => {
                console.error('Error converting file to data URL:', error)
            })
        } else if(typeof parentProps.state.avatarUrl === 'string') {
            setPreviewAvatar(parentProps.state.avatarUrl)
        } else {
            setPreviewAvatar('')
        }
    }, [parentProps.state.avatarUrl])


    const renderHeader = () => {
        return (
            <div className={'bpw-header-container'}  style={{ background: widgetTheme?.variant === 'soft' ? '#ffffff' :  chatThemeColor, borderRadius: `${widgetTheme?.radius}px ${widgetTheme?.radius}px 0px 0px` }}>
                <div className={'bpw-header-title-flexbox'}>
                    <div className={'bpw-header-title-container'}>
                        <div className={'bpw-bot-avatar'}>
                            {previewAvatar && <img height={40} width={40} src={previewAvatar} style={{border: `solid 3px ${widgetTheme?.variant === 'soft' ? '#ffffff' : chatThemeColor}`}} />}
                            {!previewAvatar && (
                                <svg width={40} height={40} style={{border: `solid 3px ${widgetTheme?.variant === 'soft' ? '#ffffff' : chatThemeColor}`}}>
                                <text textAnchor={'middle'} x={'50%'} y={'50%'} dy={'0.35em'} fill={'#ffffff'} fontSize={15}>
                                    {botName && botName[0]}
                                </text>
                                </svg>
                            )}
                        </div>
                        <div className={'bpw-header-title'}>
                            <div className={'bpw-header-name'} style={{ color: widgetTheme?.variant === 'solid' ? userBubbleTheme?.text : '#333333'}}>
                                {botName}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='bot-close-btn'>
                    <button
                        type="button"
                        id="btn-close"
                        className={'bpw-header-icon bpw-header-icon-close'}
                        onClick={toggleChat}
                        // onClick={() => {}}
                    >
                        <Close fill={ widgetTheme?.variant === 'solid' ? userBubbleTheme?.text : chatThemeColor}/>
                    </button>
                </div>
            </div>
        )
    }
    const solidThemeForUserMessage = {
        backgroundColor: userBubbleTheme?.bubble,
        color: userBubbleTheme?.text,
        border: `1px solid ${userBubbleTheme?.bubble}`,
        borderRadius: `${widgetTheme?.radius}px ${widgetTheme?.radius}px 4px ${widgetTheme?.radius}px`
    }

    const softThemeForUserMessage = {
        backgroundColor: '#ffffff',
        color: userBubbleTheme?.text,
        border: `1px solid ${userBubbleTheme?.bubble}`,
        borderRadius: `${widgetTheme?.radius}px ${widgetTheme?.radius}px 4px ${widgetTheme?.radius}px`
    }

    const themeForBotMessage = {
        backgroundColor: botBubbleTheme.bubble,
        color: botBubbleTheme.text,
        borderRadius: `${widgetTheme?.radius}px ${widgetTheme?.radius}px ${widgetTheme?.radius}px 4px`
    }
    const renderChats = () => {
        return (
            <div
                className={'bpw-msg-list-container'}
                style={{padding: '20px 12px'}}
            >
                <div style={{overflowY: 'auto'}}>
                    <div>
                        <div role="main" className="bpw-message-big-container bpw-from-user">
                            <div role="region" className="bpw-message-container">
                                <div aria-live="assertive" role="log" className="bpw-message-group">
                                    <div className="bpw-bubble-undefined bpw-chat-bubble bpw-bubble-text" data-from="Me">
                                        <div className="bpw-chat-bubble-content" style={widgetTheme?.variant === 'soft' ? softThemeForUserMessage : solidThemeForUserMessage}>
                                            Hello
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div role="main" className="bpw-message-big-container bpw-from-bot">
                            <div className="bpw-bot-avatar">
                            <div className={'bpw-bot-avatar'}>
                                {previewAvatar && <img height={40} width={40} src={previewAvatar} />}
                                {!previewAvatar && (
                                    <svg width={40} height={40}>
                                    <text textAnchor={'middle'} x={'50%'} y={'50%'} dy={'0.35em'} fill={'#ffffff'} fontSize={15}>
                                        {botName && botName[0].toUpperCase()}
                                    </text>
                                    </svg>
                                )}
                            </div>
                            </div>
                            <div role="region" className="bpw-message-container">
                                <div aria-live="assertive" role="log" className="bpw-message-group">
                                    <div className="bpw-bubble-undefined bpw-chat-bubble bpw-bubble-text" data-from="Virtual Assistant">
                                        <div className="bpw-chat-bubble-content"  style={themeForBotMessage}>
                                            Hello, how can I help you?
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const renderComposer = () => {
        return (
            <div className="bpw-keyboard">
                <div></div>
                <div role="region" className="bpw-composer">
                    <div className="bpw-composer-inner" style={{ borderRadius: `${widgetTheme?.radius}px`}}>
                        <div className="bpw-composer-textarea">
                            <textarea style={{fontSize: '14px'}} id="input-message" value={''} onChange={(e) => {
                                e.preventDefault()
                                }} placeholder={parentProps.state.composerPlaceholder} aria-label="Message to send" ></textarea>
                        </div>
                        <div className="bpw-send-buttons">
                            <button className="bpw-emoji-button" id="btn-emoji" style={{border: 'none', background: 'none'}} onClick={(e) => {
                                e.preventDefault()
                                }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g transform="translate(1.667 1.667)" stroke={chatThemeColor} fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                                        <circle cx="8.333" cy="8.333" r="8.333"></circle>
                                        <path stroke-width="2" d="M5 5.833h.008M11.658 5.833h.009"></path>
                                        <path d="M12.175 10A4.167 4.167 0 0 1 10 12.175a4.225 4.225 0 0 1-3.25 0A4.167 4.167 0 0 1 4.492 10"></path>
                                    </g>
                                </svg>
                            </button>
                            <button className="bpw-send-button" aria-label="Send" id="btn-send" onClick={(e) => {
                                e.preventDefault()
                                }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g stroke={chatThemeColor} fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M2.5 1.667 18.24 10 2.5 18.333 5.278 10zM8.981 10H5.278"></path>
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div
            className={'bpw-layout bpw-chat-container bpw-layout-fullscreen fullscreen'}
            style={{backgroundColor: 'transparent', position: 'relative', width: '360px', height: '75%', bottom: '0', right: '0', borderRadius: `${widgetTheme?.radius}px`}}
        >
            {renderHeader()}
            {renderChats()}
            {renderComposer()}
            <span>
                <div className="bpw-powered" style={{color: '#808080a1', borderRadius: `0px 0px ${widgetTheme?.radius}px ${widgetTheme?.radius}px`}}>
                    <span>
                        <span>Powered by <a style={{color: '#808080a1'}} href="https://www.enablex.io" target="_blank">EnableX</a></span>
                    </span>
                </div>
            </span>
        </div>
    )
}
